import { render, staticRenderFns } from "./VideoModuleSetting.vue?vue&type=template&id=055d6382&scoped=true&"
import script from "./VideoModuleSetting.vue?vue&type=script&lang=js&"
export * from "./VideoModuleSetting.vue?vue&type=script&lang=js&"
import style0 from "./VideoModuleSetting.vue?vue&type=style&index=0&id=055d6382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d6382",
  null
  
)

export default component.exports